import React from 'react';
import { designTokens } from '../../styles/design-tokens';
import { useTheme } from '../../context/ThemeContext';

interface FilterChipProps {
  label: string;
  active: boolean;
  color: string;
  onClick: () => void;
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, active, color, onClick }) => {
  const { theme } = useTheme();

  return (
    <button
      onClick={onClick}
      style={{
        padding: '3px 8px',
        fontSize: '10px',
        fontWeight: 600,
        background: active ? color + '20' : theme.inputBg,
        color: active ? color : theme.textSecondary,
        border: `1px solid ${active ? color + '60' : color + '30'}`,
        borderRadius: '4px',
        cursor: 'pointer',
        fontFamily: designTokens.typography.fontFamily.display,
      }}
    >
      {label}
    </button>
  );
};
